module.exports = __webpack_public_path__ + "static/img/logo-strategio.384abd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-strategio.png
// module id = KDbQ
// module chunks = 3